<template>
  <Tweet
    tweet_link="https://x.com/ArbitrumPlay/status/1617610433028050944"
    image_name="arbitrum.jpg"
    name="Arbitrum Play"
    handle="@ArbitrumPlay"
    is_verified
  >
    If you're looking for a fun, and simplified way to read data on the
    blockchain,
    <b>@bubblemaps</b> have just integrated #Arbitrum on their platform💙🧡
  </Tweet>
</template>

<script>
import Tweet from "@/components/atoms/Tweet.vue";

export default {
  components: {
    Tweet,
  },
};
</script>
